import React, { useState } from 'react';
import Papa from 'papaparse';
import {
  Box,
  Button,
  LinearProgress,
  Typography,
  Paper,
} from '@mui/material';

const DownloadProductCsv = () => {
  const [loading, setLoading] = useState(false);

  const fetchAndDownloadCSV = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/get-exhibitors-products-without-pagination');
      const json = await res.json();
      const { items } = json.data;

      const csvData = [];

      items.forEach(product => {
        csvData.push({
          type: 'product',
          woocommerce_product_id: product.woocommerce_product_id ?? '',
          variation_id: '',
          event_name: product.event_name ?? '',
          price: product.price ?? '',
          stock: product.total_exhibitor ?? '',
          updated_price: '',
          updated_stock: '',
        });

        product.variants?.forEach(variant => {
          csvData.push({
            type: 'variant',
            woocommerce_product_id: variant.product_id ?? '',
            variation_id: variant.product_variant_id ?? '',
            event_name: variant.name ?? '',
            price: variant.price ?? '',
            stock: variant.stock ?? '',
            updated_price: '',
            updated_stock: '',
          });
        });
      });

      const csv = Papa.unparse(csvData);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'products-and-variants.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('CSV download error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={1} sx={{ p: 2, maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="subtitle1" gutterBottom>
        Download Products CSV
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          onClick={fetchAndDownloadCSV}
          disabled={loading}
          size="small"
          sx={{ fontSize: '0.75rem', width: 'fit-content' }}
        >
          {loading ? 'Generating CSV...' : 'Download CSV'}
        </Button>

        {loading && (
          <Box>
            <LinearProgress />
            <Typography variant="caption" display="block" mt={1}>
              Preparing your CSV file...
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default DownloadProductCsv;
